var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "create-view",
    {
      attrs: { "body-style": { height: "100%" } },
      on: { afterEnter: _vm.afterEnter },
    },
    [
      _c(
        "flexbox",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "xr-create",
          attrs: { direction: "column", align: "stretch" },
        },
        [
          _c(
            "flexbox",
            { staticClass: "xr-create__header" },
            [
              !_vm.$slots.title
                ? _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._t("title"),
              _vm._v(" "),
              _c("i", {
                staticClass: "el-icon-close close",
                on: { click: _vm.close },
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "xr-create__body" }, [_vm._t("default")], 2),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "xr-create__footer" },
            [
              _vm.showCancel
                ? _c(
                    "el-button",
                    {
                      nativeOn: {
                        click: function ($event) {
                          return _vm.close.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("取消")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("footer"),
              _vm._v(" "),
              _vm.showConfirm
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.debouncedSaveField(false)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.confirmButtonText))]
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }